export default "__VITE_ASSET__a$MuusLb__"